import { render, staticRenderFns } from "./MetadataNode.vue?vue&type=template&id=90e76846"
import script from "./MetadataNode.vue?vue&type=script&lang=js"
export * from "./MetadataNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports